import './googlemap'
import mapstyle from '../../json/mapStyle.json'
/*****
 * GoogleMap API
 */
export default () => {
  
  /*****
   * GoogleMap API読み込み
   */
  const [w,d,h,s,km,host] = [window,document,'head','script',window.siteinfo.mapApiKeys,location.host]
  const env_map_key = (!km[host]) ? km['local'] : km[host]
  const f=d.getElementsByTagName(h)[0],j=d.createElement(s);
  j.src=`https://maps.googleapis.com/maps/api/js?key=${env_map_key}&callback=load.mapScript.resolve`;f.insertBefore(j, null);

  /*****
   * googlemap実行
   */
  $.when(
    w.load.mapScript
  ).done(() => {
    if(w.google == undefined) return false;
    if( $('[data-plugin="googlemap"]').length > 0 ){
      const $map = $('[data-plugin="googlemap"]'),
            styleObj = { name:'mapstyle', style:mapstyle};
      $map.googlemap({styleObj});
    }else{
      const $map = $('<div />',{class:'p-map','data-zoom':'16'}).insertBefore($.UA.is_pc?'footer':'.homeContentslist'),
            markers = w.siteinfo.map,
            styleObj = { name:'mapstyle', style:mapstyle}
      $map.googlemap({markers,styleObj})
    }
  });


}